import { ref, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useSurveyTypesList() {
  // Use toast
  const toast = useToast()

  const refSurveyTypeListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'title', label: 'Title', sortable: true },
    { key: 'typekey', label: 'Key', sortable: true },
    { key: 'description', label: 'Description', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]
  const perPage = ref(10)
  const totalSurveyTypes = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const allSurveyTypes = ref([])

  const dataMeta = computed(() => {
    const localItemsCount = refSurveyTypeListTable.value ? refSurveyTypeListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalSurveyTypes.value,
    }
  })

  const refetchData = () => {
    fetchSurveyTypes()
  }

  const fetchSurveyTypes = () => {
    store
      .dispatch('app-survey-types/fetchSurveyTypes', {})
      .then(response => {
        const { data, totalSurveyTypes: total } = response.data
        allSurveyTypes.value = data
        totalSurveyTypes.value = total || data.length
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching survey types list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const filteredSurveyTypes = computed(() => {
    let filtered = allSurveyTypes.value

    // Search filter
    if (searchQuery.value) {
      const query = searchQuery.value.toLowerCase()
      filtered = filtered.filter(item => {
        return (
          (item.title && item.title.toLowerCase().includes(query)) ||
          (item.typekey && item.typekey.toLowerCase().includes(query)) ||
          (item.description && item.description.toLowerCase().includes(query))
        )
      })
    }

    totalSurveyTypes.value = filtered.length
    return filtered
  })

  const resolveStatusVariant = status => {
    if (status === 1) return 'success'
    if (status === 0) return 'secondary'
    return 'primary'
  }

  const resolveStatusText = status => {
    if (status === 1) return 'Active'
    if (status === 0) return 'Inactive'
    return 'Unknown'
  }

  return {
    fetchSurveyTypes,
    filteredSurveyTypes,
    tableColumns,
    perPage,
    currentPage,
    totalSurveyTypes,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refSurveyTypeListTable,
    refetchData,
    resolveStatusVariant,
    resolveStatusText,
  }
}
